export function toggleAddToCartButtonState( state: boolean ): void {
	const submit = document.getElementsByClassName( 'single_add_to_cart_button' );

	if ( ! submit.length ) {
		return;
	}

	for ( const element of submit ) {
		element[ 'disabled' ] = state;
	}
}

